import React, { useCallback, useState } from 'react';
import { FitToViewport } from './components/FitToViewport';
import { PresentationBar } from './components/PresentationBar';
import { Simulator } from './components/Simulator';
import { ConceptModal } from './components/concept/ConceptModal';
type AppProps = {
  /** Shows the captured insight events beneath the simulator (for demos / research sessions). */
  showInsightLog?: boolean;
  /** Open the concept window on load. */
  conceptOpenOnLoad?: boolean;
};
export function App({
  showInsightLog = false,
  conceptOpenOnLoad = false
}: AppProps) {
  const [conceptOpen, setConceptOpen] = useState(conceptOpenOnLoad);
  const closeConcept = useCallback(() => setConceptOpen(false), []);
  return <div className="min-h-screen w-full bg-paper" data-id="element-0" data-mp="2wj8fnurpiy7c">
      <FitToViewport data-id="element-1" data-mp="28u5x8kp911bs">
        <PresentationBar onOpenConcept={() => setConceptOpen(true)} data-id="element-2" data-mp="28tme50nv46w6" />
        <Simulator showInsightLog={showInsightLog} fit data-id="element-3" data-mp="23vcikoy874a1" />
      </FitToViewport>
      <ConceptModal open={conceptOpen} onClose={closeConcept} data-id="element-4" data-mp="23t8gmcjw0fce" />
    </div>;
}